import type {ProductCatalogue} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/productCataloguesWorkspaceCapability/domain/ProductCatalogue";
import type {ProductCatalogueTemplate} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/productCataloguesWorkspaceCapability/domain/ProductCatalogueTemplate";
import {processOttopilotStringTemplate} from "@vesta/vos-types/modules/workspaceLevel/domain/OttopilotStringTemplate";

export function getProductCatalogueDisplayName(
    product: ProductCatalogue,
    templates: ReadonlyArray<ProductCatalogueTemplate>,
): string {
    const template = templates.find((item) => item.id === product.templateId);
    if (template === undefined) {
        return product.id;
    }
    const displayName = processOttopilotStringTemplate(
        template.instanceDisplayNameTemplate,
        product.additionalColumnValues,
    );
    return displayName.trim() === "" ? product.id : displayName;
}
